<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      notFooterPadding
      @cancel="cancel"
      @confirm="confirm">
    <template #header>添加日志</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="75px"
          >
        <el-form-item
            label="日志日期"
            prop="logDate"
            :rules="[
              { required: true, message: '请选择日志日期', trigger: ['change'] }
            ]">
          <gj-date-picker
              v-model="form.logDate"
              :clearable="false"
              width="385px"
          ></gj-date-picker>
        </el-form-item>
        <el-form-item
            label="日志类型"
            prop="type"
            :rules="[
              { required: true, message: '请选择日志类型', trigger: ['change'] }
            ]">
          <gj-select
              v-model="form.type"
              :clearable="false"
              :options="typeOption"
              width="100%"
          ></gj-select>
        </el-form-item>
        <el-form-item
            label="日志内容"
            prop="content"
            :rules="[
              { required: true, message: '请选择日志内容', trigger: ['change'] }
            ]">
          <gj-textarea
              v-model="form.content"
              :styles="{height: '120px', width: '100%'}"
              class="form-input">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formValidatorMixin, modalMixIn, responseMixin} from "../../../../../../../minxins";
  import {addOperationLog} from "../../../../../../../api/sale";
  import {OperationLogEnum} from "../../../common/enum";
  import {convertToDate} from "../../../../../../../utils/date.util";

  export default {
    name: "app-add-asin-operation-log-modal",
    mixins: [modalMixIn, formValidatorMixin, responseMixin],
    props: {
      typeOption: {
        required: true
      },
      dimension: {
        required: true
      },
      marketId: {
        required: true,
      },
      asin: {
        required: true
      },
      variationAsin: {
        type: String
      },
      countryCode: {
        type: String
      }
    },
    data() {
      return {
        form: {
          logDate: null,
          type: null,
          content: null
        }
      }
    },
    methods: {
      confirm() {
        if (this.formValidate()) {
          this.confirmLoading = true;
          const params = {
            dimension: this.dimension,
            marketId: this.marketId,
            countryCode: this.countryCode,
            logDate: convertToDate(this.form.logDate),
            type: this.form.type,
            content: this.form.content,
          };
          if (this.dimension === OperationLogEnum.dimension.ASIN) {
            params.asin = this.asin;
          } else {
            params.variationAsin = this.variationAsin;
          }
          addOperationLog(params)
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('添加成功');
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style scoped>
/deep/.gj-modal--footer .el-dialog__footer{
  padding-top: 0;
}
</style>
